import { __decorate } from "tslib";
import { HttpClient, HttpParams } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { ApplicationSummaryConstants } from "../application-summary.constants";
import { SharedConstants } from "../../../constants/shared.constants";
import { ApiApplicationStatusConstants } from "../../../constants/api-constants/api-application-summary.constants";
import { ApiLookupConstants } from "../../../constants/api-constants/api-lookup.constants";
let ApplicationSummaryService = class ApplicationSummaryService {
    httpClient;
    filterApplicationsByStatusEvent = new EventEmitter();
    isLoadingSummaryBhv = new BehaviorSubject(null);
    $isLoadingSummaryObs = this.isLoadingSummaryBhv.asObservable();
    selectedCategory = new BehaviorSubject(ApplicationSummaryConstants.CATEGORY_PLACEHOLDER);
    $selectedCategory = this.selectedCategory.asObservable();
    setObservableSharedItemsActors(data) {
        this.isLoadingSummaryBhv.next(data);
    }
    setSelectedCategory(category) {
        this.selectedCategory.next(category);
    }
    get isLoadingSummary() {
        return this.isLoadingSummaryBhv.value;
    }
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLatestApplications(moduleId, url, category, expandFields) {
        let filter = `status/daysUntilExpired gt 0 and status/daysUntilExpired lt ${ApplicationSummaryConstants.DAYS_LIMIT} and moduleId eq ${moduleId}`;
        if (category !== null) {
            filter += ` and status/category eq '${category}'`;
        }
        const params = new HttpParams()
            .append("$expand", expandFields)
            .append("$filter", filter)
            .append("$top", ApplicationSummaryConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${url}${SharedConstants.NOT_BUSY_INDICATOR}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getOverdueApplications(moduleId, url, category, expandFields) {
        let filter = `status/daysUntilExpired gt ${ApplicationSummaryConstants.DAYS_LIMIT} and moduleId eq ${moduleId}`;
        if (category !== null) {
            filter += ` and status/category eq '${category}'`;
        }
        const params = new HttpParams()
            .append("$expand", expandFields)
            .append("$filter", filter)
            .append("$orderby", "status/daysUntilExpired desc")
            .append("$top", ApplicationSummaryConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${url}${SharedConstants.NOT_BUSY_INDICATOR}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getStatusCount(moduleId, category) {
        const params = new HttpParams()
            .append("$orderby", "count desc")
            .append("$top", ApplicationSummaryConstants.DAYS_LIMIT.toString());
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}/${moduleId}/${ApiApplicationStatusConstants.FUNCTION_COUNT_STATUS}${SharedConstants.NOT_BUSY_INDICATOR}?category=${category}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getStatusTotalCount(moduleId, category) {
        let filter = `applicationJobLink/moduleId eq ${moduleId}`;
        if (category !== "") {
            filter += ` and category eq '${category}'`;
        }
        const params = new HttpParams()
            .append("$expand", "applicationJobLink")
            .append("$filter", filter)
            .append("$count", "true")
            .append("$top", "0");
        return this.httpClient
            .get(`${ApiApplicationStatusConstants.URL}${SharedConstants.NOT_BUSY_INDICATOR}`, { params })
            .pipe(map((data) => {
            return data["@odata.count"];
        }));
    }
    filterApplicationsByStatus(status) {
        this.filterApplicationsByStatusEvent.emit(status);
    }
    getLookupsObservable(params) {
        return this.httpClient.get(`${ApiLookupConstants.URL}`, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ApplicationSummaryService = __decorate([
    Injectable({
        providedIn: "root",
    })
], ApplicationSummaryService);
export { ApplicationSummaryService };
